var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrow = function SvgArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2678 15C11.0376 16.3333 11.4225 17 11.9999 17C12.5772 17 12.9621 16.3333 13.7319 15L15.464 12C16.2338 10.6667 16.6187 10 16.33 9.5C16.0413 9 15.2715 9 13.7319 9H10.2678C8.72821 9 7.95841 9 7.66974 9.5C7.38106 10 7.76596 10.6667 8.53576 12L10.2678 15Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow.26e9f590a3acaa1b0bd9a531f9688a92.svg";